import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import { GetRankingInfoResponse } from './Ranking.types';

export const getRankingAsync = async (): Promise<
  ApiResponseType<GetRankingInfoResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetRankingInfoResponse>>(
    `/package/ranking`
  );
  return data;
};

export const claimPackageRankAsync = async (
  packageRankSelectedRewardId: number
): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/package/rank/reward/claim`,
    {
      packageRankSelectedRewardId
    }
  );
  return data;
};
